import Vue from 'vue';

let EventBus = new Vue();

Object.assign(EventBus, {
    'LOGIN_START': 'LOGIN_START',
    'LOGIN_DONE': 'LOGIN_DONE',
    'LOGOUT_DONE': 'LOGOUT_DONE',
    'REMOTE_LOGIN_CANCELED': 'REMOTE_LOGIN_CANCELED',

    'SWITCH_LANGUAGE_START': 'SWITCH_LANGUAGE_START',
    'SWITCH_LANGUAGE_DONE': 'SWITCH_LANGUAGE_DONE',

    'BOOTSTRAP_START': 'BOOTSTRAP_START',
    'BOOTSTRAP_DONE': 'BOOTSTRAP_DONE',
    'BOOTSTRAP_RESET': 'BOOTSTRAP_RESET',

    'UPDATE_CHECKS': 'UPDATE_CHECKS',
    'UPDATE_CHECKS_DONE': 'UPDATE_CHECKS_DONE',

    'USER_HAS_NO_NO_CAMPGROUND': 'USER_HAS_NO_NO_CAMPGROUND',

    'CAMPGROUND_CHANGED': 'CAMPGROUND_CHANGED',

    'FETCH_BOOKINGS_START': 'FETCH_BOOKINGS_START',
    'FETCH_BOOKINGS_DONE': 'FETCH_BOOKINGS_DONE',
    'FETCH_BOOKING_DETAIL_START': 'FETCH_BOOKING_DETAIL_START',
    'FETCH_BOOKING_DETAIL_DONE': 'FETCH_BOOKING_DETAIL_DONE',
    'FETCH_USER_START': 'FETCH_USER_START',
    'FETCH_USER_DONE': 'FETCH_USER_DONE',

    'UPDATE_SETTINGS_START': 'UPDATE_SETTINGS_START',
    'UPDATE_SETTINGS_DONE': 'UPDATE_SETTINGS_DONE',

    'UPDATE_USER_START': 'UPDATE_USER_START',
    'UPDATE_USER_DONE': 'UPDATE_USER_DONE',

    'FETCH_SEASONS_START': 'FETCH_SEASONS_START',
    'FETCH_SEASONS_DONE': 'FETCH_SEASONS_DONE',
    'ADD_SEASONS_START': 'ADD_SEASONS_START',
    'ADD_SEASONS_DONE': 'ADD_SEASONS_DONE',
    'UPDATE_SEASONS_START': 'UPDATE_SEASONS_START',
    'UPDATE_SEASONS_DONE': 'UPDATE_SEASONS_DONE',
    'DELETE_SEASONS_START': 'DELETE_SEASONS_START',
    'DELETE_SEASONS_DONE': 'DELETE_SEASONS_DONE',

    'FETCH_AVAILABILITIES_START': 'FETCH_AVAILABILITIES_START',
    'FETCH_AVAILABILITIES_DONE': 'FETCH_AVAILABILITIES_DONE',

    'FETCH_CHANGED_AVAILABILITIES_START': 'FETCH_CHANGED_AVAILABILITIES_START',
    'FETCH_CHANGED_AVAILABILITIES_DONE': 'FETCH_CHANGED_AVAILABILITIES_DONE',

    'SHOW_NOTIFICATION': 'SHOW_NOTIFICATION',

    'WS_MESSAGE_RECEIVED': 'WS_MESSAGE_RECEIVED',
    'ERROR': 'ERROR',
});

export default EventBus;



// WEBPACK FOOTER //
// ./src/utils/EventBus.js